import * as types from '../mutation_types';

export default {
  [types.SET_CALENDAR](state, value) {
    state.calendar = value;
  }
}
